import { render, staticRenderFns } from "./ComposeBox.vue?vue&type=template&id=7fafb05e&scoped=true&"
import script from "./ComposeBox.vue?vue&type=script&lang=js&"
export * from "./ComposeBox.vue?vue&type=script&lang=js&"
import style0 from "./ComposeBox.vue?vue&type=style&index=0&id=7fafb05e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fafb05e",
  null
  
)

export default component.exports